"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAll = exports.killAll = exports.kill = exports.setLocation = exports.setScanned = exports.setVisited = exports.create = void 0;
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var imports_1 = require("@lib/imports");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var objs = [];
function create(i, j, x, y) {
    var id = common_sidecar_1.common.createId();
    var imageBack = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().starmapBack, sprites_sidecar_1.sprites.voyStarmapHidden[0]);
    imageBack.x = x;
    imageBack.y = y;
    var obj = {
        eType: 'tile-starmap',
        id: id,
        idLoaded: 0,
        isDead: false,
        imageBack: imageBack,
        imageLocation: null,
        imageDanger: null,
        location: null,
        isRevealed: false,
        isVisited: false,
        x: x,
        y: y,
        i: i,
        j: j,
        // hasBackgroundAsteroids: false,
    };
    objs.push(obj);
    updateBack(obj);
    return obj;
}
exports.create = create;
function setVisited(tile, isVisited) {
    tile.isVisited = isVisited;
    if (isVisited) {
        tile.isRevealed = true;
    }
    updateBack(tile);
    setLocationIcon(tile);
}
exports.setVisited = setVisited;
function setScanned(tile, isScanned) {
    tile.isRevealed = isScanned;
    updateBack(tile);
    setLocationIcon(tile);
}
exports.setScanned = setScanned;
function updateBack(tile) {
    var frame = sprites_sidecar_1.sprites.voyStarmapHidden;
    if (tile.isRevealed) {
        frame = sprites_sidecar_1.sprites.voyStarmapVisible;
    }
    if (tile.isVisited) {
        frame = sprites_sidecar_1.sprites.voyStarmapVisited;
    }
    spritesUtil_sidecar_1.spritesUtil.setPackedFrame(tile.imageBack, frame[0]);
}
function setDangerIcon(tile, dangerLevel) {
    if (dangerLevel <= 0) {
        if (tile.imageDanger) {
            tile.imageDanger.destroy();
            tile.imageDanger = null;
        }
        return;
    }
    var dangerFrame = dangerLevel >= 3
        ? sprites_sidecar_1.sprites.voyStarmapDanger3
        : dangerLevel >= 2
            ? sprites_sidecar_1.sprites.voyStarmapDanger2
            : sprites_sidecar_1.sprites.voyStarmapDanger1;
    if (dangerFrame) {
        if (!tile.imageDanger) {
            tile.imageDanger = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().starmapLocation, dangerFrame[0]);
            tile.imageDanger.x = tile.x;
            tile.imageDanger.y = tile.y;
        }
        else {
            spritesUtil_sidecar_1.spritesUtil.setPackedFrame(tile.imageDanger, dangerFrame[0]);
        }
    }
    else {
        if (tile.imageDanger) {
            tile.imageDanger.destroy();
            tile.imageDanger = null;
        }
    }
}
function setLocationIcon(tile) {
    var location = tile.location;
    if (!location) {
        if (tile.imageLocation) {
            tile.imageLocation.destroy();
            tile.imageLocation = null;
        }
        setDangerIcon(tile, 0);
    }
    else {
        var frames_1 = sprites_sidecar_1.sprites.voyStarmapUnknown;
        var dangerLevel = 0;
        if (tile.isRevealed) {
            frames_1 = location.frames;
            dangerLevel = location.dangerLevel;
        }
        if (!tile.imageLocation) {
            tile.imageLocation = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().starmapLocation, frames_1[0]);
            tile.imageLocation.x = tile.x;
            tile.imageLocation.y = tile.y;
        }
        else {
            spritesUtil_sidecar_1.spritesUtil.setPackedFrame(tile.imageLocation, frames_1[0]);
        }
        setDangerIcon(tile, dangerLevel);
    }
}
function setLocation(tile, location) {
    tile.location = location;
    setLocationIcon(tile);
    // if (data && data.hasBackgroundAsteroids) {
    //   tile.hasBackgroundAsteroids = true
    // } else {
    //   tile.hasBackgroundAsteroids = false
    // }
}
exports.setLocation = setLocation;
function kill(obj) {
    obj.isDead = true;
}
exports.kill = kill;
function killAll() {
    imports_1.l.forEach(objs, function (c) {
        c.isDead = true;
    });
}
exports.killAll = killAll;
function updateAll() {
    // objs.forEach((c) => {
    //   update(c)
    // })
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        if (c.imageBack) {
            c.imageBack.destroy();
        }
        if (c.imageLocation) {
            c.imageLocation.destroy();
        }
    });
}
exports.updateAll = updateAll;
